import { render } from "./todoHeader.vue?vue&type=template&id=483d1a18&scoped=true"
import script from "./todoHeader.vue?vue&type=script&lang=js"
export * from "./todoHeader.vue?vue&type=script&lang=js"

import "./todoHeader.vue?vue&type=style&index=0&id=483d1a18&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-483d1a18"

export default script